import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  ref: "map",
  class: "map"
}
const _hoisted_2 = {
  ref: "popup",
  id: "tooltip",
  role: "tooltip"
}
const _hoisted_3 = { class: "headline" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "text" }
const _hoisted_6 = {
  key: 0,
  class: "text"
}
const _hoisted_7 = {
  key: 1,
  class: "text"
}
const _hoisted_8 = {
  key: 0,
  class: "search-area-button",
  ref: "areaSearchButton"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, null, 512),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedCCs, (selectedCC, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["ccenter-item", { 'mb-3': _ctx.selectedCCs.length > 1 }])
        }, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.isHomeSite)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: _ctx.getCCLink(selectedCC.id)
                }, _toDisplayString(selectedCC.name), 9, _hoisted_4))
              : _createCommentVNode("", true),
            (!_ctx.isHomeSite)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: {
              name: 'counseling-center',
              params: { ccid: selectedCC.id }
              //params: { ccid: center.id,  topics: topics, region: region, lang: lang, cType: cType, targetGroup: targetGroup}
            }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(selectedCC.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(selectedCC.address?.zipCode) + " " + _toDisplayString(selectedCC.address?.city) + ", " + _toDisplayString(selectedCC.address?.streetName) + " " + _toDisplayString(selectedCC.address?.houseNumber), 1),
          (!_ctx.isHomeSite && selectedCC.phone)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(selectedCC.phone), 1))
            : _createCommentVNode("", true),
          (!_ctx.isHomeSite && selectedCC.email)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(selectedCC.email), 1))
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ], 512),
    (_ctx.showSearchAreaOverlay && _ctx.showSearchAreaButton)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitAreaSearch && _ctx.emitAreaSearch(...args)))
          }, _toDisplayString(_ctx.$t('viewer.areaSearchButton')), 1)
        ], 512))
      : _createCommentVNode("", true)
  ], 64))
}